<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="760px">
      <v-card>
        <v-card-title>
          <span>
            {{ $t('wkt.admin.vacation-policy.update-balance-dialog.title') }}
          </span>
        </v-card-title>

        <v-card-text>
          <div>
            <span>
              {{ descriptionText }}
            </span>
          </div>

          <v-form ref="form">
            <div>
              <v-switch
                v-model="accumulateVacation"
                :label="$t('wkt.admin.vacation-policy.update-balance-dialog.acc-vacation-days')"
              />
            </div>

            <v-text-field
              v-model="confirmationText"
              dense
              :label="confirmationLabel"
              :rules="[confirmationRule]"
            />
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#185EA9"
            text
            @click="confirm"
          >
            <span>
              {{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}
            </span>
          </v-btn>
          <v-btn
            text
            @click="showDialog = false"
          >
            <span>
              {{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from '../../common/BaseModule'

export default {
  name: 'VacationPolicyBalanceResetDialog',
  mixins: [BaseModule],
  data () {
    return {
      showDialog: false,
      callback: null,
      options: null,
      confirmationText: '',
      accumulateVacation: true
    }
  },
  computed: {
    confirmationToken () {
      return this.$t('wkt.admin.vacation-policy.update-balance-dialog.text-to-validate')
    },
    bagLabel () {
      return this.options && this.options.bagLabel
        ? this.options.bagLabel
        : '---'
    },
    descriptionText () {
      return this.formatTemplate(
        this.$t('wkt.admin.vacation-policy.update-balance-dialog.description'),
        this.bagLabel
      )
    },
    confirmationLabel () {
      return this.formatTemplate(
        this.$t('wkt.admin.vacation-policy.update-balance-dialog.establish'),
        this.confirmationToken
      )
    }
  },
  methods: {
    open (options, callback) {
      this.options = options || {}
      this.callback = callback
      this.confirmationText = ''
      this.accumulateVacation = true

      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }

      this.showDialog = true
    },
    formatTemplate (template, value) {
      return String(template || '').replace('%s', value)
    },
    confirmationRule (value) {
      return value === this.confirmationToken || this.$t('wkt.admin.vacation-policy.update-balance-dialog.error')
    },
    confirm () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.showDialog = false

      if (this.callback) {
        this.callback({
          accumulateVacation: Boolean(this.accumulateVacation)
        })
      }
    }
  }
}
</script>